import React, { FC } from "react";

import { CatalogListPage } from "./CatalogList";

const CollectionPage: FC = () => {
  return <CatalogListPage isCollection={true} />;
};

export default CollectionPage;
